export const GET_QUESTION_IMAGES = 'GET_QUESTION_IMAGES';
export const DELETE_QUESTION_IMAGE = 'DELETE_QUESTION_IMAGE';

export const DEFAULT_AVATAR_ICON_PATH = '/images/icon_default_avatar.png';
